export default __webpack_public_path__ + "beta-maps-example-point-annotation-1200-1d177899ce69b7f479aac1cea584751d.png";